import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import formValueSelector from "redux-form/lib/formValueSelector";
import actions from "redux-form/lib/actions";
import Immutable from "immutable";
import isArray from "lodash/isArray";
import $ from "jquery";
import isEqual from "lodash/isEqual";

import "./index.scss";

import ProductGroupRow from "./ProductGroupRow";
import TotalRow from "./TotalRow";

/**
 * Overview
 */
class Index extends Component {
  static propTypes = {
    extraProductDiscountMultiplier: PropTypes.number,
    items: PropTypes.instanceOf(Immutable.List).isRequired,
    schema: PropTypes.instanceOf(Immutable.Map).isRequired,
    t: PropTypes.func.isRequired,
    hasCartACard: PropTypes.bool.isRequired,
    formArrayRemove: PropTypes.func.isRequired,
    isCartEmpty: PropTypes.bool.isRequired,
    totals: PropTypes.instanceOf(Immutable.Map).isRequired
  };

  static defaultProps = {
    extraProductDiscountMultiplier: 0
  };

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  onRemoveProduct = product => {
    this.props.formArrayRemove("cart", "items", product.get("itemIndex"));
    $(window).trigger("debloemist.cart.updated");
  };

  onRemoveExtraProduct = product => {
    this.props.formArrayRemove(
      "cart",
      `items[${product.get("parentItemIndex")}].extraProducts`,
      product.get("itemIndex")
    );
    $(window).trigger("debloemist.cart.updated");
  };

  render() {
    if (this.props.isCartEmpty) {
      return null;
    }
    // console.log(this.props.allocations.toJS());
    const { t, totals } = this.props;
    return (
      <div className="Cart__Overview">
        <div className="Cart__Overview__Title">{t("overviewTitle")}</div>

        <div className="Cart__Overview__Header">
          <div className="col-12 col-md-6">{this.props.t("products")}</div>
          <div className="col-12 col-md-2">{this.props.t("recipient")}</div>
          <div className="col-12 col-md-2">{this.props.t("quantity")}</div>
          <div className="col-12 col-md-2">{this.props.t("price")}</div>
        </div>

        {this.props.items.map((product, idx) => (
          <ProductGroupRow
            key={`productGroup${product.get("uuid", "")}${product.get("webProductId")}${product.get("id")}`}
            schema={this.props.schema}
            product={product.set("itemIndex", idx)}
            onRemove={this.onRemoveProduct}
            onRemoveExtraProduct={this.onRemoveExtraProduct}
            extraProductDiscountMultiplier={this.props.extraProductDiscountMultiplier}
          />
        ))}

        {/* eslint-disable react/no-array-index-key */
        this.props.items.size > 0 &&
          totals.keySeq().map(key => {
            const item = totals.get(key);
            if (isArray(item)) {
              return item.map((props, idx) => (
                <TotalRow key={key + idx} id={key} {...props} t={t} forceOtherCosts={this.props.hasCartACard} />
              ));
            }
            return <TotalRow key={key} id={key} value={item} t={t} forceOtherCosts={this.props.hasCartACard} />;
          })
        /* eslint-enable react/no-array-index-key */
        }
      </div>
    );
  }
}

const valuesSelector = formValueSelector("cart");

const selectCart = createSelector(
  [
    state => valuesSelector(state, "items"),
    state => valuesSelector(state, "customer"),
    state => valuesSelector(state, "recipients"),
    state => valuesSelector(state, "checkout.payment.type")
  ],
  (items, customer, recipients, checkout) =>
    Immutable.fromJS({
      items,
      customer,
      recipients,
      checkout
    })
);

const selectCartItems = createSelector(
  [state => selectCart(state), state => state.cart.get("context")],
  (cart, context) => {
    const itemContexts = context.get("itemContexts");
    return cart
      .get("items")
      .map(item => {
        const itemContext = itemContexts.find(ctx => ctx.get("webProductId") === item.get("webProductId"));
        if (!itemContext) {
          return null;
        }
        let pcm = itemContext.get("items").find(i => i.get("id") === item.get("productCollectionMemberId"));
        if (!pcm) {
          return null;
        }

        pcm = pcm.set("uuid", item.get("uuid"));
        pcm = pcm.set("webProductId", item.get("webProductId"));
        pcm = pcm.set("title", `${pcm.get("title")}`);
        pcm = pcm.set("quantity", item.get("quantity"));
        pcm = pcm.set("imageId", itemContext.get("imageId"));
        pcm = pcm.set("imageVersionId", itemContext.get("imageVersionId"));

        const extraProducts = itemContext.get("extraProducts");
        pcm = pcm.set(
          "extraProducts",
          item
            .get("extraProducts")
            .map(p => {
              let ep = extraProducts.find(i => i.get("id") === p.get("id"));
              if (!ep) {
                return null;
              }
              if (ep.get("id") === -123) {
                // vase
                ep = ep.set("priceEx", pcm.get("vasePriceEx", ep.get("priceEx")));
              }
              return ep.set("uuid", p.get("uuid")).set("quantity", item.get("quantity"));
            })
            .filter(v => !!v)
        );
        return pcm;
      })
      .filter(v => !!v);
  }
);

const selectCartTotals = createSelector(
  [state => state.cart.get("totals")],
  totals => totals
);

const selectCartContext = createSelector(
  [state => state.cart.get("context")],
  context => context
);

const selectCartHasCard = createSelector(
  [state => selectCart(state)],
  cart =>
    cart.get("recipients").reduce((carry, recipient) => {
      if (
        recipient.getIn(["card", "type"]) &&
        (recipient.getIn(["card", "text", "left"], recipient.getIn(["card", "text"], null)) ||
          recipient.getIn(["address", "street"]))
      ) {
        carry = true;
      }
      return carry;
    }, false)
);

export default translate()(
  connect(
    state => ({
      context: selectCartContext(state),
      schema: state.cart.get("schema"),
      isCartEmpty: selectCartItems(state).size === 0,
      items: selectCartItems(state),
      totals: selectCartTotals(state),
      hasCartACard: selectCartHasCard(state),
      defaultTaxMultiplier: state.cart.getIn(["context", "defaultTaxMultiplier"]),
      extraProductDiscountMultiplier: state.cart.getIn(["context", "extraProductDiscountMultiplier"])
    }),
    {
      formArrayRemove: actions.arrayRemove
    }
  )(Index)
);
